import { render, staticRenderFns } from "./VisualConfig.vue?vue&type=template&id=3799576e&scoped=true"
import script from "./VisualConfig.vue?vue&type=script&lang=js"
export * from "./VisualConfig.vue?vue&type=script&lang=js"
import style0 from "./VisualConfig.vue?vue&type=style&index=0&id=3799576e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799576e",
  null
  
)

export default component.exports